<template>
  <div class="create-wrapper">
    <div class="tabs">
      <span :class="{ active : active === 'createBlog' }" @click="active = 'createBlog'">Blog</span>
      <span :class="{ active : active === 'createNews' }" @click="active = 'createNews'">News</span>
    </div>
    <keep-alive>
      <component :is="getActiveComponent" />
    </keep-alive>
  </div>
</template>

<script>
import createBlog from '@/components/admin/createBlog.vue'
import createNews from '@/components/admin/createNews.vue'
export default {
  name: 'Create',
  components: {
    createBlog,
    createNews
  },
  data () {
    return {
      active: 'createBlog'
    }
  },
  computed: {
    getActiveComponent () {
      return this.active
    }
  }
}
</script>

<style lang="scss" scoped>
.create-wrapper {
  .tabs {
    margin-bottom: 20px;
    span {
      margin-right: 20px;
      cursor: pointer;
    }
    span:last-child {
      margin-right: 0px;
    }
    span.active {
      color: $main-color;
    }
  }
}
</style>
